import { SubscriptionTier } from '@wwe-portal/entities/subscription.type';
import { cn } from '@wwe-portal/ui/lib/lib';

export const subscriptionMap = {
  [SubscriptionTier.BRONZE]: {
    name: 'Premium',
  },
  [SubscriptionTier.SILVER]: {
    name: 'Prestige',
  },
  [SubscriptionTier.GOLD]: {
    name: 'SuperVIP',
  },
};

export const TierBadge = ({
  tier,
  className,
}: {
  tier: SubscriptionTier | undefined;
  className?: string;
}) => {
  return (
    <div className="flex h-full items-start justify-start">
      <div
        className={cn(
          'font-poppins border-bronzetier text-2xs flex h-5 w-[52px] items-center justify-center rounded-[4px] border-[1px] border-solid font-normal',
          className
        )}
      >
        {tier ? subscriptionMap[tier].name : null}
      </div>
    </div>
  );
};
